import React from "react";
import FlightTicketAgencyPage from "./FlightTicketAgencyPage";

function App() {
  return <FlightTicketAgencyPage />;
}

export default App;

